import { useIntl } from 'react-intl'
import { OverlayPanel } from '../Routing'
import { useSelector } from 'react-redux'
import { InstantOffer } from './InstantOffer'
import ShouldYouSell from '../MarketSpotlight/ShouldYouSell'
import ValuationPanelManager from '../../homeowners/Valuation'
import { OVERLAY_HELPERS } from '../../../constants/navigation'
import OverlayDefaultHeader from '../Routing/Headers/OverlayDefaultHeader'
import { MarketSpotlight, MarketSpotlightHeader } from '../MarketSpotlight'
import { selectHomeFactsProgress } from '../../../store/selectors/valuation'
import AvmHotMarketWarning from './Chart/Warnings/AvmHotMarket/AvmHotMarketWarning'
import NonDisclosureWarning from './Chart/Warnings/NonDisclosure/NonDisclosureWarning'
import AvmDifferenceWarning from './Chart/Warnings/AvmDifference/AvmDifferenceWarning'
import EquitySmartSearchCalculation from '../MarketSpotlight/EquitySmartSearchTable/EquitySmartSearchCalculation'
import { HomePriceIndexWidgetWizard } from '../../homeowners/HomePriceIndex/HomePriceIndexWidgetWizard'
import { useAvmModuleContext } from './AvmModuleContext'

export const AvmModuleOverlayPanels = () => {
  const intl = useIntl()
  const homeFactsProgress = useSelector(selectHomeFactsProgress)
  const context = useAvmModuleContext()

  return (
    <>
      <OverlayPanel
        back={OVERLAY_HELPERS.instantOffer.getOrigin()}
        path={OVERLAY_HELPERS.instantOffer.buildPath()}
        title={OVERLAY_HELPERS.getTitle('instantOffer', intl.formatMessage)}
        anchorOffset={250}
        component={InstantOffer}
        renderHeader={props => <OverlayDefaultHeader {...props} progress={homeFactsProgress} />}
      />
      <OverlayPanel
        back={OVERLAY_HELPERS.tuneYourValue.getOrigin()}
        path={OVERLAY_HELPERS.tuneYourValue.buildPath()}
        title={OVERLAY_HELPERS.getTitle('tuneYourValue', intl.formatMessage)}
        anchorOffset={250}
        component={ValuationPanelManager}
        renderHeader={props => <OverlayDefaultHeader {...props} progress={homeFactsProgress} />}
      />
      <OverlayPanel
        back={OVERLAY_HELPERS.marketSpotlight.getOrigin()}
        path={OVERLAY_HELPERS.marketSpotlight.buildPath()}
        title={OVERLAY_HELPERS.getTitle('marketSpotlight', intl.formatMessage)}
        anchorOffset={250}
        component={MarketSpotlight}
        renderHeader={props => <MarketSpotlightHeader {...props} />}
      />
      <OverlayPanel
        back={OVERLAY_HELPERS.equitySmartSearch.getOrigin()}
        path={OVERLAY_HELPERS.equitySmartSearch.buildPath()}
        title={OVERLAY_HELPERS.getTitle('equitySmartSearch', intl.formatMessage)}
        anchorOffset={250}
        component={EquitySmartSearchCalculation}
      />
      <OverlayPanel
        back={OVERLAY_HELPERS.avmDiffWarning.getOrigin()}
        path={OVERLAY_HELPERS.avmDiffWarning.buildPath()}
        title={OVERLAY_HELPERS.getTitle('avmDiffWarning', intl.formatMessage)}
        anchorOffset={200}
        component={AvmDifferenceWarning}
      />
      <OverlayPanel
        back={OVERLAY_HELPERS.avmHotMarketWarning.getOrigin()}
        path={OVERLAY_HELPERS.avmHotMarketWarning.buildPath()}
        title={OVERLAY_HELPERS.getTitle('avmHotMarketWarning', intl.formatMessage)}
        anchorOffset={200}
        component={AvmHotMarketWarning}
      />
      <OverlayPanel
        back={OVERLAY_HELPERS.nonDisclosureWarning.getOrigin()}
        path={OVERLAY_HELPERS.nonDisclosureWarning.buildPath()}
        title={OVERLAY_HELPERS.getTitle('nonDisclosureWarning', intl.formatMessage)}
        anchorOffset={200}
        component={NonDisclosureWarning}
      />
      <OverlayPanel
        back={OVERLAY_HELPERS.shouldYouSell.getOrigin()}
        path={OVERLAY_HELPERS.shouldYouSell.buildPath()}
        title={OVERLAY_HELPERS.getTitle('shouldYouSell', intl.formatMessage)}
        anchorOffset={200}
        component={ShouldYouSell}
      />
      <OverlayPanel
        back={OVERLAY_HELPERS.homePriceIndexWidget.getOrigin()}
        path={OVERLAY_HELPERS.homePriceIndexWidget.buildPath()}
        title={OVERLAY_HELPERS.getTitle('homePriceIndexWidget', intl.formatMessage)}
        anchorOffset={250}
        component={HomePriceIndexWidgetWizard}
        onClose={() => context.state.setWizardInProgress(false)}
        renderHeader={props => <OverlayDefaultHeader {...props} />}
      />
    </>
  )
}
